'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./flex.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Flex(_ref) {
  var className = _ref.className,
      gutter = _ref.gutter,
      align = _ref.align,
      alignSelf = _ref.alignSelf,
      background = _ref.background,
      direction = _ref.direction,
      expand = _ref.expand,
      justify = _ref.justify,
      wrap = _ref.wrap,
      margin = _ref.margin,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['className', 'gutter', 'align', 'alignSelf', 'background', 'direction', 'expand', 'justify', 'wrap', 'margin', 'children']);

  var classes = (0, _classnames2.default)('flex', align && 'flex--align-' + align, alignSelf && 'flex--align-self-' + alignSelf, gutter && 'flex--gutter-' + gutter, direction && 'flex--direction-' + direction, expand && 'flex--expanded', justify && 'flex--justify-' + justify, wrap && 'flex--flex-wrap-' + wrap, margin && 'flex--margin-' + margin, background && 'flex--background-' + background, className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    children
  );
}

Flex.propTypes = {
  align: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'baseline', 'stretch']),
  alignSelf: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'baseline', 'stretch']),
  background: _propTypes2.default.oneOf(['white', 'light']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['row', 'column', 'row-reverse', 'column-reverse']),
  expand: _propTypes2.default.bool,
  gutter: _propTypes2.default.oneOf(['none', 'xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  justify: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  wrap: _propTypes2.default.oneOf(['wrap', 'nowrap']),
  margin: _propTypes2.default.oneOf(['medium', 'none'])
};

Flex.defaultProps = {
  gutter: 'medium',
  margin: 'medium'
};

exports.default = Flex;